import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from 'src/components';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

export default function ConfirmationDialog({
  open,
  title,
  content,
  onCancel,
  onConfirm,
  confirmText = "Yes",
  cancelText = "Cancel"
}) {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{
        sx: {
          borderRadius: 2,
          minWidth: 280,
          maxWidth: 300,
        },
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        gap: 1.5,
        fontSize: '1.1rem',
        fontWeight: 600
      }}>
        <WarningAmberIcon color="error" fontSize="small" />
        {title}
      </DialogTitle>

      <DialogContent sx={{ pt: 0, pb: 1, textAlign: 'center'}}>
        <Typography variant="body2">
          {content}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ mb: 1, gap: 1, justifyContent: 'center' }}>
        <Button 
          onClick={onCancel} 
          variant="outlined" 
          size="small"
          sx={{ minWidth: 100 }}
        >
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          size="small"
          sx={{ minWidth: 100 }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}